import React, { Component } from 'react';
import { Row, Col } from 'react-bootstrap';
import moment from 'moment';
import Auth from '../../Auth/Auth';
import IsLoadingBar from '../isLoading';

import './Discussions.scss';

const auth = new Auth();

function copy(e){
    let copybtn = e.target
    copybtn.className = "fas fa-check copy-btn";
    setTimeout(function(){
        copybtn.className = "far fa-copy copy-btn";
    },1500);
}

export default class Discussions extends Component {
    constructor(props){
        super(props);

        this.state = {
            DiscussionId : this.props.DiscussionId,
            DiscussionQuestion: [],
            DiscussionReplyLevelOne: [],
            DiscussionReplyLevelTwo: [],
            DiscussionReplyLevelThree: [],
            VerifedReply: [],
            BestComment: [],
            isLoading: true
        };
    }

    async componentDidMount(){
        let accessToken = await auth.getToken();
        let DiscussionId = this.props.DiscussionId;
        fetch('/api/getDiscussion', {
            method : "GET",
            headers : {
                'Authorization': "Bearer " + accessToken,
                withCredentials : true,
                crossDomain: true,
                discussionid : DiscussionId
            }
        }).then(response => {
            if(response.status !== 200)
            {   
                let payload = [{
                    status : response.status,
                    rawmsg : response.statusText,
                    cleanmsg : response.status + " was thrown with the message of " + response.statusText + " on " + response.url,
                    location: response.url,
                    timestamp : Date.now(),
                }];
                throw {
                    payload: payload,
                    error: new Error()
                };
            }
            return  response.json();
        })
        .then(data => {
              this.setState({
                DiscussionQuestion : data[0].filter(discussion => discussion.DiscussionType === "Question"),
                DiscussionReplyLevelOne : data[0].filter(discussion => discussion.DiscussionType === "Reply" && discussion.ThreadLevel === 0).sort(function (a, b) {
                    return new Date(a.CreatedDate) - new Date(b.CreatedDate);
                  }),
                DiscussionReplyLevelTwo : data[0].filter(discussion => discussion.DiscussionType === "Reply" && discussion.ThreadLevel === 1).sort(function (a, b) {
                    return new Date(a.CreatedDate) - new Date(b.CreatedDate);
                  }),
                DiscussionReplyLevelThree : data[0].filter(discussion => discussion.DiscussionType === "Reply" && discussion.ThreadLevel === 2).sort(function (a, b) {
                    return new Date(a.CreatedDate) - new Date(b.CreatedDate);
                  }),
                BestComment : data[0].filter(discussion => discussion.BestCommentId !== null).length > 0 ? data[0].filter(discussion => discussion.DiscussionType === "Reply" && discussion.Id === data[0].filter(discussion => discussion.BestCommentId !== null)[0].BestCommentId) : [],
                VerifiedReply : data[0].filter(discussion => discussion.DiscussionType === "Reply" && discussion.IsVerified === 1),
                isLoading: false
              });
              setTimeout(function(){
                let chosenReply = document.querySelector(`[data-id="${DiscussionId}"`); 
                let discussionModal = document.querySelector("#discussion");  
   
                if(chosenReply){
                    chosenReply.style.outline = "solid #b4daff 5px";
                    var headerOffset = 100;
                    var elementPosition = chosenReply.getBoundingClientRect().top;
                    var offsetPosition = elementPosition - headerOffset;

                    discussionModal.scrollTo({
                        top: offsetPosition,
                        behavior: "smooth"
                    });
                }                
            },1000);
        }).catch((error) => {
            console.error('Error:', error);
            window.apiError(error);
          });
    }

    componentDidUpdate(prevProps){
        if(prevProps.DiscussionId !== this.props.DiscussionId){
            this.setState({
                DiscussionId : this.props.DiscussionId
            });
        }
    }

    render(){
        return (
            <Row id="discussion">
                <Col lg={{ span : 9}}> 
                {!this.state.isLoading ? 
                <div>
                    {this.state.DiscussionQuestion.map((items, index) => 
                        <div className="question" style={{margin : "25px", color: "#717171"}} key={index}>
                            <h6><strong>Question</strong></h6>     
                            <p style={{fontSize: "14px"}}><strong>Community Link: </strong><a href={`https://community.ceridian.com/s/feed/${this.props.DiscussionId}`} rel="noopener noreferrer" target="_blank">{`https://community.ceridian.com/s/feed/${this.props.DiscussionId}`}</a><i className="far fa-copy copy-btn" onClick={(e) => copy(e)} data-clipboard-text={`https://community.ceridian.com/s/feed/${this.props.DiscussionId}`}></i></p>
                                                   
                            <div className="left-block">
                                <div className="name-circle">
                                    <i className="fas fa-user"></i>
                                </div>
                            </div>
                            <div className="right-block">
                                <h6 className="font-weight-bold">{items.CompanyName || "No Account Name"}</h6>
                                <h6><strong>{items.Title || "No Title"}</strong></h6>
                                <small className="float-left w-100  mb-3"><strong>Date Created: </strong> {moment(items.CreatedDate).format("YYYY-MM-DD")}</small>
                                <h6 dangerouslySetInnerHTML={{ __html : items.Body }}></h6>
                                
                            </div>                       
                        </div>
                    )}

                    <h6 className="ml-4"><strong>Top Answer(s)</strong></h6>                
                    <div className="replys top-answer mb-4 ml-4">
                        <div>
                            {this.state.VerifiedReply.length > 0 && (
                                <h6 style={{fontWeight: "600"}}>Verified Answer</h6>
                            )}                            
                            {this.state.VerifiedReply.map((verified,index) =>
                            <div className="reply-item shadow-sm mb-2" key={index}>
                                <div className="left-block">
                                    <div className="name-circle">
                                        <i className="fas fa-user"></i>
                                    </div>
                                </div>
                                <div className="right-block">
                                    <h6 className="font-weight-bold">{verified.CompanyName || "No Account Name"}</h6>
                                    <small className="float-left w-100 mb-3">{moment(verified.CreatedDate).format("YYYY-MM-DD") }</small>
                                    <h6 dangerouslySetInnerHTML={{ __html : verified.Body }}></h6>
                                </div>
                            </div>   
                            )}

                            {this.state.BestComment.length > 0 && (
                                <h6 style={{fontWeight: "600"}}>Best Answer</h6>
                            )}                            
                            {this.state.BestComment.map((verified,index) =>
                            <div className="reply-item shadow-sm mb-2" key={index}>
                                <div className="left-block">
                                    <div className="name-circle">
                                        <i className="fas fa-user"></i>
                                    </div>
                                </div>
                                <div className="right-block">
                                    <h6 className="font-weight-bold">{verified.CompanyName || "No Account Name"}</h6>
                                    <small className="float-left w-100 mb-3">{moment(verified.CreatedDate).format("YYYY-MM-DD") }</small>
                                    <h6 dangerouslySetInnerHTML={{ __html : verified.Body }}></h6>
                                </div>
                            </div>   
                            )}
                        </div>                    
                    </div>

                    <h6 className="ml-4"><strong>All Answer's</strong></h6>
                    <div className="replys all-answers ml-4 mb-4">                    
                        {this.state.DiscussionReplyLevelOne.map((replyOne, index) => 
                        <div key={index}>
                            <div className="reply-item shadow-sm" data-id={replyOne.Id}>
                                <div className="left-block">
                                    <div className="name-circle">
                                        <i className="fas fa-user"></i>
                                    </div>
                                </div>
                                <div className="right-block">
                                    <h6 className="font-weight-bold">{replyOne.CompanyName  || "No Account Name"}</h6>
                                    <small className="float-left w-100 mb-3">{moment(replyOne.CreatedDate).format("YYYY-MM-DD") }</small>
                                    <h6 dangerouslySetInnerHTML={{ __html : replyOne.Body }}></h6>
                                </div>
                            </div> 
                            <div>
                                {this.state.DiscussionReplyLevelTwo.map((replyTwo, index) => 
                                <div key={index}>
                                    {replyTwo.ThreadParentId === replyOne.Id ?
                                    <div className="ml-5">
                                        <div className="reply-item shadow-sm"   data-id={replyTwo.Id}>
                                            <div className="left-block">
                                                <div className="name-circle">
                                                    <i className="fas fa-user"></i>
                                                </div>
                                            </div>
                                            <div className="right-block">
                                                <h6 className="font-weight-bold">{replyTwo.CompanyName || "No Account Name"}</h6>
                                                <small className="float-left w-100  mb-3">{moment(replyTwo.CreatedDate).format("YYYY-MM-DD")}</small>
                                                <h6 dangerouslySetInnerHTML={{ __html : replyTwo.Body }}></h6>
                                            </div>                                        
                                        </div>
                                        {this.state.DiscussionReplyLevelThree.map((replyThree, index) => 
                                        <div className="ml-5" key={index} >
                                        {replyThree.ThreadParentId === replyTwo.Id ?
                                            <div className="reply-item shadow-sm"  data-id={replyThree.Id}>
                                                <div className="left-block">
                                                    <div className="name-circle">
                                                        <i className="fas fa-user"></i>
                                                    </div>
                                                </div>
                                                <div className="right-block">
                                                    <h6 className="font-weight-bold">{replyThree.CompanyName || "No Account Name"}</h6>
                                                    <small className="float-left w-100  mb-3">{moment(replyThree.CreatedDate).format("YYYY-MM-DD")}</small>
                                                    <h6 dangerouslySetInnerHTML={{ __html : replyThree.Body }}></h6>
                                                </div>
                                            </div>
                                        : null }
                                        </div>
                                        )} 
                                    </div>
                                    : null } 
                                    
                                </div>                                            
                                )}
                            </div>
                        </div>                      
                        )}
                    </div>
                
                </div>  
                :
                <IsLoadingBar />
                }
                </Col>
                <Col lg={{ span : 3}}>
                    
                </Col>
            </Row>       
       );
    }
}

